import React from 'react'
import PropTypes from 'prop-types'
import Slide from './Slide'
import './BlankSlide.css'

class BlankSlide extends Slide {

    render() {
        
        return super.render(
            <div className='BlankSlide'>
                <span>{ this.props.title }</span>
            </div>
        )
    }
}
 
BlankSlide.propTypes = {
    title: PropTypes.any.isRequired,
}

export default BlankSlide;





// WEBPACK FOOTER //
// ./src/components/BlankSlide.js